{
  "welcome": "Welcome to",
  "instructions": "Tap below to begin your check-in process.",
  "startCheckIn": "Start check-in",
  "missingWarehouseTitle": "Missing Warehouse",
  "missingWarehouseMessage": "The link is invalid, it must contain the Warehouse ID",
  "recaptchaAttribution": "This site is protected by reCAPTCHA and the Google {privacyPolicy} and {termsOfService} apply.",
  "recaptchaPrivacyPolicy": "Privacy Policy",
  "recaptchaTermsOfService": "Terms of Service",
  "lookupTitle": "Add the Reference or Confirmation Number to find your appointment",
  "referenceNumberLabel": "Reference number or Confirmation number",
  "referenceNotFoundError": "The reference or confirmation number doesn't match any valid appointments.",
  "checkIn": "Check in",
  "loadTypeLabel": "Load type",
  "directionLabel": "Direction",
  "operationLabel": "Operation",
  "dockLabel": "Dock",
  "orDivider": "or",
  "noReferenceTitle": "I don't have a confirmation number",
  "noReferenceDescription": "Proceed without an appointment using the standard check-in process.",
  "checkInWithoutAppointment": "Check in without an appointment",
  "readyToCheckInTitle": "Ready to check in?",
  "readyToCheckInDescription": "Tap below to start. You'll enter your details on the next screen.",
  "referenceRequiredHint": "A reference number is required to check in at this location.",
  "haveAppointment": "I have an appointment",
  "direction": {
    "inbound": "Inbound",
    "outbound": "Outbound",
    "inOut": "Inbound & Outbound",
    "load": "Load",
    "unload": "Unload"
  },
  "operation": {
    "live": "Live",
    "drop": "Drop",
    "other": "Other"
  }
}
